import React from 'react';
import '../../styles/coffee.scss';

function Coffee() {
  return (
    <a
      className='blue'
      target='_blank'
      href='https://www.buymeacoffee.com/brandenBoyington'
      rel='noreferrer'>
      <img
        src='https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg'
        alt='Buy me a coffee'
      />
      <span>Buy me a coffee</span>
    </a>
  );
}

export default Coffee;
